<template>
    <div class="">
        
        <template>
            <the-header />
        </template>

        <div class="site-wrapper-reveal">
            <div class="about-banner-wrap banner-space about-us-bg position-relative">
                <div class="banner-overlay"></div>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-8 ml-auto mr-auto">
                            <div class="about-banner-content text-center">
                                <h1 class="mb-15 text-white">Axis Realty Homes For Rent</h1>
                                <h5 class="font-weight--normal text-white">Proven 15 years’ track record in property management. </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="feature-large-images-wrapper section-space--pt_60">
                <div class="container">
                    <div class="cybersecurity-about-box">
                        <div class="row">
                            <div class="col-lg-4">
                                <div class="conact-us-wrap-one managed-it">
                                    <h5 class="heading ">Find the Perfect Home </h5>
                                </div>
                            </div>
                            <div class="col-lg-7 offset-lg-1">
                                <div class="button-group-wrap sm:text-right text-center">
                                    <router-link :to="`${baseUrl}/apply-for-rental`" class="ht-btn ht-btn-md mr-4 mb-5 inline-block text-white">Apply For Rental</router-link>
                                    <router-link :to="`${baseUrl}/contact-us`" class="ht-btn ht-btn-md ht-btn--solid inline-block">Inquire Now</router-link>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <!-- <div class="search-wrapper">
                <div class="container">
                    <div class="row">                        
                        <div class="col-lg-12">
                            <div class="search-form-wrap">
                                <div class="contact-title text-center section-space--mb_20">
                                    <h5 class="mb-10">Search</h5>
                                </div>
                                <form action="#">
                                    <div class="search-form">
                                        <div class="row">
                                            <div class="col-md-5">
                                                <div class="contact-inner">
                                                    <label class="font-weight--reguler">Address</label>
                                                    <input name="address" type="text" placeholder="address, city, postal code, description">
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="contact-inner">
                                                    <label class="font-weight--reguler">Rent Amount</label>
                                                    <div class="d-flex">
                                                        <input name="rent_amount_to" type="text">
                                                        <span class="ml-10 mr-10 mt-10">To</span>
                                                        <input name="rent_amount_from" type="text">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="contact-select">
                                                    <label class="font-weight--reguler">Beds</label>
                                                    <div class="form-item contact-inner">
                                                        <span class="beds">
                                                            <select name="beds" class="select-item">
                                                                <option value=""></option>
                                                                <option value="0">0+</option>
                                                                <option value="1">1+</option>
                                                                <option value="2">2+</option>
                                                                <option value="3">3+</option>
                                                                <option value="4">4+</option>
                                                                <option value="5">5+</option>
                                                                <option value="6">6+</option>
                                                                <option value="7">7+</option>
                                                                <option value="8">8+</option>
                                                                <option value="9">9+</option>
                                                                <option value="10">10+</option>
                                                            </select>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="contact-select">
                                                    <label class="font-weight--reguler">Baths</label>
                                                    <div class="form-item contact-inner">
                                                        <span class="baths">
                                                            <select name="baths" class="select-item">
                                                                <option value=""></option>
                                                                <option value="0">0+</option>
                                                                <option value="0.5">0.5+</option>
                                                                <option value="1">1+</option>
                                                                <option value="1.5">1.5+</option>
                                                                <option value="2">2+</option>
                                                                <option value="2.5">2.5+</option>
                                                                <option value="3">3+</option>
                                                                <option value="3.5">3.5+</option>
                                                                <option value="4">4+</option>
                                                                <option value="4.5">4.5+</option>
                                                                <option value="5">5+</option>
                                                                <option value="5.5">5.5+</option>
                                                                <option value="6">6+</option>
                                                                <option value="6.5">6.5+</option>
                                                                <option value="7">7+</option>
                                                                <option value="7.5">7.5+</option>
                                                                <option value="8">8+</option>
                                                                <option value="8.5">8.5+</option>
                                                                <option value="9">9+</option>
                                                                <option value="9.5">9.5+</option>
                                                                <option value="10">10+</option>
                                                            </select>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="contact-select">
                                                    <label class="font-weight--reguler">Pets</label>
                                                    <div class="form-item contact-inner">
                                                        <span class="pets">
                                                            <select name="pets" class="select-item">
                                                                <option value="">Select One......</option>
                                                                <option value="1">Dogs Allowed</option>
                                                                <option value="2">Cats Allowed</option>
                                                                <option value="3">Dogs &amp; Cats Allowed</option>
                                                                <option value="4">No Pets Allowed</option>
                                                            </select>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="contact-select">
                                                    <label class="font-weight--reguler">Sort By</label>
                                                    <div class="form-item contact-inner">
                                                        <span class="sort_by">
                                                            <select name="sort by" class="select-item">
                                                                <optgroup label="Proximity">
                                                                    <option value="">Closest to Search</option>
                                                                </optgroup>
                                                                <optgroup label="Date Posted">
                                                                    <option value="date|desc">Date Posted (new - old)</option>
                                                                    <option value="date">Date Posted (old - new)</option>
                                                                </optgroup>
                                                                <optgroup label="Price">
                                                                    <option value="amount">Price (low - high)</option>
                                                                    <option value="amount|desc">Price (high - low)</option>
                                                                </optgroup>
                                                                <optgroup label="Beds">
                                                                    <option value="beds">Beds (low - high)</option>
                                                                    <option value="beds|desc">Beds (high - low)</option>
                                                                </optgroup>
                                                                <optgroup label="Baths">
                                                                    <option value="baths">Baths (low - high)</option>
                                                                    <option value="baths|desc">Baths (high - low)</option>
                                                                </optgroup>
                                                                <optgroup label="Area (Sq.Ft.)">
                                                                    <option value="area">SqFt (low - high)</option>
                                                                    <option value="area|desc">SqFt (high - low)</option>
                                                                </optgroup>
                                                                <optgroup label="Availability Date">
                                                                    <option value="availabilityDate">Availability (sooner - later)</option>
                                                                    <option value="availabilityDate|desc">Availability (later - sooner)</option>
                                                                </optgroup>
                                                            </select>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="comment-submit-btn text-right">
                                            <button class="ht-btn ht-btn-md" type="button">Search</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->

            <div class="feature-large-images-wrapper section-space--ptb_60">
                <div class="container">
                    <div class="cybersecurity-about-box">
                        <div class="row">
                            <div class="col-lg-12">
                                <section id="place-order" class="list-view product-checkout">
                                    <div class="checkout-items">
                                        <div class="card ecommerce-card mt-40" v-for="(property, index) in propertiesResponse.properties" :key="index">
                                            <div class="card-content">
                                                <div class="item-img text-center">
                                                    <router-link :to="`${baseUrl}/home-for-rent/${property.id}`">
                                                        <img :src="property.images[0]" class="responsive rounded-lg p-4" alt="axis realty group">
                                                    </router-link>
                                                </div>
                                                <div class="card-body p-4 pt-6">
                                                    <h6 class="item-name">
                                                        <router-link :to="`${baseUrl}/home-for-rent/${property.id}`" class="text-dark hover:text-primary">{{property.address}}</router-link>
                                                        <span></span>
                                                    </h6>
                                                    <p class="delivery-date">{{property.address}}<br>
                                                        {{property.property_type}} - Available: Immediately</p>
                                                </div>
                                                <div class="item-options text-center">
                                                    <div class="item-wrapper">
                                                        <div class="item-cost">
                                                            <h6 class="item-price">
                                                                {{property.rent | currency('$ ', 2, { thousandsSeparator: ',' })}}
                                                            </h6>
                                                            <p class="shipping">
                                                                USD / Month
                                                            </p>
                                                            <div class="item-details">
                                                                <span>Beds: {{property.property_type}}</span>
                                                                <span>Baths: {{property.bathrooms}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <router-link :to="`${baseUrl}/home-for-rent/${property.id}`" class="d-block cart remove-wishlist text-white mt-20">
                                                        View Details
                                                    </router-link>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <vs-pagination
                                            :total="propertiesResponse.count"
                                            :max="10"
                                            v-model="currentPage" />

                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
            
        <the-footer />
    </div>
</template>

<script>
import TheHeader   from '@/layouts/components/TheHeader.vue'
import TheFooter   from '@/layouts/components/TheFooter.vue'
import UserProperty from '@/js/userProperty.js'

export default {
  components: {
    TheHeader,
    TheFooter
  },
  data () {
    return {
      propertiesResponse: {},
      selectedPage: 1
    }
  },
  methods: {
    setFullVacantProperties (propertiesResponse) {
      console.log('propertiesResponse', propertiesResponse)
      this.propertiesResponse = propertiesResponse
    }
  },
  created () {
    UserProperty.getFullVacantPropertiesList(this)
  },
  computed: {
    baseUrl () {
      const path = this.$route.path
      return path.slice(0, ('/'))
    },
    currentPage: {
      get () {
        return 1
      },
      set (val) {
        this.slectedPage = val
        this.selectedPage = val
        UserProperty.getFullVacantPropertiesList(this)
      }
    }
  }

}
</script>